var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0418 2.16699L1.9585 27.8337M9.12516 5.83366C9.12516 7.8587 7.52085 9.50032 5.54183 9.50032C3.56281 9.50032 1.9585 7.8587 1.9585 5.83366C1.9585 3.80861 3.56281 2.16699 5.54183 2.16699C7.52085 2.16699 9.12516 3.80861 9.12516 5.83366ZM27.0418 24.167C27.0418 26.192 25.4375 27.8337 23.4585 27.8337C21.4795 27.8337 19.8752 26.192 19.8752 24.167C19.8752 22.1419 21.4795 20.5003 23.4585 20.5003C25.4375 20.5003 27.0418 22.1419 27.0418 24.167Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropLight);
export default __webpack_public_path__ + "static/media/prop_light.39d920eabf7a526120e673ce67424660.svg";
export { ForwardRef as ReactComponent };